<app-header></app-header>

<div class="container cf-flex-column">
  <h2 translate>UI.Auth.RecoverPassword</h2>

  <ng-container *ngIf="status$ | async as status">
    <!-- View state: email input -->
    <form *ngIf="status.status === PasswordRecoverStatus.EmailInput" novalidate (submit)="send()">
      <app-text-input
        [required]="true"
        labelTextId="User.Email"
        [inputControl]="recoverPasswordEmail"
        subscriptSizing="fixed"
        inputType="email"
      ></app-text-input>

      <div class="form-button">
        <button mat-flat-button color="primary" type="submit">{{ 'UI.Auth.ResetPassword' | translate }}</button>
      </div>
    </form>

    <!-- View state: sending link -->
    <div *ngIf="status.status === PasswordRecoverStatus.SendingLink">
      <div class="spinner-container cf-flex-row cf-justify-content-center">
        <mat-spinner></mat-spinner>
      </div>
      <p [innerHtml]="'UI.Auth.SendingRecoveryLinkTo' | translate : { email: status.email }"></p>
    </div>

    <!-- View state: link successfully sent -->
    <div *ngIf="status.status === PasswordRecoverStatus.LinkSent">
      <p [innerHtml]="'UI.Auth.PasswordRecoveryLinkSentTo' | translate : { email: status.email }"></p>
      <p>
        {{ 'UI.Auth.PasswordRecoveryNoEmailReceived' | translate }}
        <a class="ac-text-link" (click)="resendLink(status.email)" translate>UI.Auth.PasswordRecoverySendLinkAgain</a>
      </p>
    </div>

    <p><a routerLink="/login" translate>UI.Auth.BackToLogin</a></p>
  </ng-container>
</div>
